/** Bag size codes — keep in sync with backend/lookups/bag_sizes.py */

export const BAG_SIZE_KG = [5, 10, 20, 25, 30, 40, 50, 60];

export const BAG_SIZE_OPTIONS = BAG_SIZE_KG.map((kg) => ({
  value: `BAG_${kg}KG`,
  label: kg === 40 || kg === 60 ? `${kg} kg PP` : `${kg} kg`,
}));

export const LABOUR_BAG_SCOPES = [
  ...BAG_SIZE_OPTIONS,
  { value: "JUTE_BAG_40KG", label: "40 kg jute" },
  { value: "JUTE_BAG_60KG", label: "60 kg jute" },
  { value: "PP", label: "PP bag" },
  { value: "LOOSE", label: "Loose" },
];

const JUTE_LABELS = {
  JUTE_BAG_40KG: "40 kg jute",
  JUTE_BAG_60KG: "60 kg jute",
};

export const BAG_CODE_TO_KG = {
  ...Object.fromEntries(BAG_SIZE_KG.map((kg) => [`BAG_${kg}KG`, kg])),
  JUTE_BAG_40KG: 40,
  JUTE_BAG_60KG: 60,
};

export function bagScopeLabel(code) {
  if (!code) return "";
  const hit = LABOUR_BAG_SCOPES.find((b) => b.value === code);
  if (hit) return hit.label;
  return JUTE_LABELS[code] || code.replace(/_/g, " ");
}
